import EmailRuleForm from "./email-rule-form";

export default EmailRuleForm;